import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSelector, useDispatch, useStore } from "react-redux";
import 'reactjs-popup/dist/index.css'; // Import the CSS for reactjs-popup
import {
  FindAllTranslations,
  findAllTranslationsWithPagination,
  findAllTranslationsWithPrevPage,
  // FindChapterIndopak
} from "../../../../apis/FetchData";
import { addToBookmark, deleteBookmark, getAuthTokenWithOutSignUp } from "../../../../apis/PostData";
import firebase from "firebase/compat/app";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { message } from 'antd';
import { auth } from "../../../../apis/firebase_authentications";
import CopyVerseGray from "../../../../assets/images/CopyVerseGray.svg";
import CopyVerseWhite from "../../../../assets/images/CopyVerse.svg";
import Home from "../../Ui/Home/HomeUi";
import { convertToSearchableChapters } from '.././SearchableChapters';
import { SettingsReducer } from "../../../../redux/Setting"
import { getTranslationDirection } from "../../../../assets/js/translationDirection";
const SettingActions = SettingsReducer.actions;

// Compiled once at module load — not inside the component render cycle
const ARABIC_CHARS_REGEX = /[\u0600\u0610\u0640\u0650\u0660\u0670\u06E0\u06F0\u0601\u0611\u0651\u06E1\u0602\u0612\u0652\u06E2\u0603\u0613\u0653\u06E3\u0604\u0614\u0654\u06D4\u06E4\u0605\u0615\u0655\u06E5\u0616\u0656\u06D6\u0617\u0657\u06D7\u06E7\u0618\u0658\u06D8\u06E8\u0619\u0659\u06D9\u06E9\u061A\u065A\u06DA\u06EA\u061B\u064B\u065B\u06DB\u06EB\u064C\u065C\u06DC\u06EC\u061D\u064D\u065D\u066D\u06DD\u06ED\u061E\u064E\u065E\u06DE\u061F\u064F\u065F\u06DF\u06D6\u06D9\u06DA]/g;

const HomeContainer = (props) => {
  const dispatch = useDispatch();
  const store = useStore();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const chapters = useSelector((state) => state.chapters);
  const reciterNames = useSelector((state) => state.chapters.reciters);
  const selectedReciterId = useSelector((state) => state.settings.selectedReciterId);
  const selectedReciterName = useSelector((state) => state.settings.selectedReciterName);
  const showTranslation = useSelector((state) => state.settings.showTranslation);
  const selectedTranslations = useSelector((state) => state.settings.selectedTranslations);
  const jumpToVerse = useSelector((state) => state.settings.jumpToVerse);
  const playingVerse = useSelector((state) => state.settings.playingVerse);
  const playingSurah = useSelector((state) => state.settings.playingSurah);
  const playingVerseRef = useRef(null);
  const [allVerses, setAllVerses] = useState([]);
  // const [indoPakVerses, setIndoPakVerses] = useState([]);
  const [nextPageToken, setNextPageToken] = useState("");
  const [prevPageToken, setPrevPageToken] = useState("");
  const isFetchingPrevRef = useRef(false);
  const [loading, setLoading] = useState(true);
  const topOfPageRef = useRef(null);
  const hasInitiallyLoaded = useRef(null);
  const lastScrolledSurahVerse = useRef(null);
  const playState = useSelector((state) => state.settings.playState);
  const [isGrammerModalOpen, setIsGrammerModalOpen] = useState(false);
  const [grammerModalVerse, setGrammerModalVerse] = useState('');
  const [grammerModalVerseId, setGrammerModalVerseId] = useState('');
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
  const [notesData, setNotesData] = useState([]);
  const [deleteNotesId, setDeleteNotesId] = useState(null)
  const [isDeleteConfirmationsModalOpen, setIsDeleteConfirmationsModalOpen] = useState(false);
  const [isCollectionModalOpen, setIsCollectionModalOpen] = useState(false);
  const [isAddNewCollectionModalOpen, setIsAddNewCollectionModalOpen] = useState(false);
  const [isBookmarkConfirmationsModalOpen, setIsBookmarkConfirmationsModalOpen] = useState(false);
  const [user, setUser] = useState(auth.currentUser);
  const [showTooltip, setShowTooltip] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(null);
  const [showVerseHoverPopup, setShowVerseHoverPopup] = useState(false);
  const [activeVerseWordIndex, setActiveVerseWordIndex] = useState(false);
  const [activeVerseIndex, setActiveVerseIndex] = useState(false);
  const arabicFontSize = useSelector((state) => state.settings.arabicFontSize);
  const translationFontSize = useSelector((state) => state.settings.translationFontSize);
  const scriptStyle = useSelector((state) => state.settings.script);

  const ChapterOptions = convertToSearchableChapters(chapters);
  const [FirstVerse, setFirstVerse] = useState(null);
  const userTheme = useSelector((state) => state.settings.userTheme);
  const CopyVerse = userTheme === 'Dark' ? CopyVerseGray : CopyVerseWhite;
  const [cursorInsidePopupDiv, setCursorInsidePopupDiv] = useState(false);
  const [verseInView, setVerseInView] = useState(null);
  const currentFetchRef = useRef(null);

  const translatorNames = useSelector((state) => state.chapters.translators);
  
  useEffect(() => {
    getAuthTokenWithOutSignUp(user)
      // .then(idToken => {
      //   dispatch(SettingActions.updateSettings({ firebaseToken: idToken }));
      // })
      // .catch(error => {
      //   // console.error("Error:", error);
      // });
  }, [dispatch, user])

  useEffect(() => {
    if (selectedReciterName === '' && reciterNames.length > 0) {
      const initialReciterId = reciterNames[0].id;
      const initialReciterName = reciterNames[0].reciter;
      dispatch(SettingActions.updateSettings({ selectedReciterId: initialReciterId }));
      dispatch(SettingActions.updateSettings({ selectedReciterName: initialReciterName }));
    }
    if (selectedTranslations?.length === 0 && translatorNames.length > 0) {
      const defaultTranslatorNames = [
        "Saheeh International",
        "Indonesian Ministry of Religious Affairs",
        "Fateh Muhammad Jalandhry",
      ];
      const defaultTranslatorIds = translatorNames
        .filter((t) => defaultTranslatorNames.includes(t.engName))
        .map((t) => t.id);
      dispatch(SettingActions.updateSettings({ selectedTranslations: defaultTranslatorIds }));
    }
  }, [dispatch, reciterNames, selectedReciterName, translatorNames, selectedTranslations]);


  const arabicFontText = useSelector((state) => state.settings.arabicFontText);
 
  const isVariablePresent = arabicFontText !== undefined && arabicFontText !== null && arabicFontText !== 'small' && arabicFontText !== '';

  const appendToHistoryList = (originalHistoryList, newHistory) => {
    if (!originalHistoryList.some(arr => JSON.stringify(arr) === JSON.stringify(newHistory))) {
      // Check if newHistory is not already in originalHistoryList
      return [...originalHistoryList, newHistory];
    }
    return originalHistoryList;
  };

  const getAllTranslations = useCallback(async () => {
    const fetchId = `${location.pathname}-${selectedTranslations.join(",")}-${selectedReciterId}`;
    if (currentFetchRef.current === fetchId) return;
    currentFetchRef.current = fetchId;

    setLoading(true);
    setAllVerses([]);
    dispatch(SettingActions.updateSettings({ translationLoading: true }));

    let locationParts = location.pathname.split("/");
    let surah = 1;
    let verse = 1;
    if (locationParts.length > 2) {
      surah = parseInt(locationParts[1], 10) || 1;
      verse = parseInt(locationParts[2], 10) || 1;  // always an integer, never stale
    } else if (locationParts.length > 1) {
      surah = parseInt(locationParts[1], 10) || 1;
      verse = 1;  // no verse in URL → default to 1
    }

    // Append to history
    const surahName = ChapterOptions.find(option => option.value === parseInt(surah));
    try {
      const currentHistoryList = store.getState().settings.historyList;
      const updatedHistoryList = appendToHistoryList(currentHistoryList, [surahName.label, parseInt(surah), parseInt(verse)]);
      dispatch(SettingActions.updateSettings({ historyList: updatedHistoryList }));
    } catch { }

    try {
      // Step 1: Fetch Bismillah header + current page in parallel
      const bismillahFetch = (parseInt(surah) > 1 && !FirstVerse)
        ? FindAllTranslations(1, 1, selectedReciterId, selectedTranslations).catch(() => null)
        : Promise.resolve(null);

      const currentFetch = FindAllTranslations(surah, verse, selectedReciterId, selectedTranslations);

      const [bismillahRes, currentRes] = await Promise.all([bismillahFetch, currentFetch]);

      if (bismillahRes && bismillahRes.status === 200) {
        setFirstVerse(bismillahRes.data.verse && bismillahRes.data.verse[0]);
      }

      if (!currentRes || !currentRes.status) {
        message.error("Failed to load data. Please try again later.");
        setLoading(false);
        dispatch(SettingActions.updateSettings({ translationLoading: false }));
        return;
      }

      const currentVerses = currentRes.data.verse || [];
      const currentNext = currentRes.data.nextPageToken || "";
      const currentPrev = currentRes.data.prevPageToken || "";

      // Step 2: Fetch prev page + next page in parallel using tokens from Step 1
      const prevFetch = currentPrev
        ? findAllTranslationsWithPrevPage(currentPrev).catch(() => null)
        : Promise.resolve(null);
      const nextFetch = currentNext
        ? findAllTranslationsWithPagination(currentNext).catch(() => null)
        : Promise.resolve(null);

      const [prevRes, nextRes] = await Promise.all([prevFetch, nextFetch]);

      const prevVerses = (prevRes && prevRes.status && prevRes.data?.verse) ? prevRes.data.verse : [];
      const nextVerses = (nextRes && nextRes.status && nextRes.data?.verse) ? nextRes.data.verse : [];
      const nextNextToken = (nextRes && nextRes.data?.nextPageToken) || currentNext;
      const prevPrevToken = (prevRes && prevRes.data?.prevPageToken) || currentPrev;

      // Deduplicate and merge: [prevVerses ... currentVerses ... nextVerses]
      const merged = [...prevVerses, ...currentVerses, ...nextVerses];
      const seen = new Set();
      const dedupedVerses = merged.filter(v => {
        const key = `${v.chapterNo}-${v.verseNo}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      setAllVerses(dedupedVerses);
      setNextPageToken(nextNextToken);
      setPrevPageToken(prevPrevToken);
      setLoading(false);
      dispatch(SettingActions.updateSettings({ translationLoading: false }));
      hasInitiallyLoaded.current = true;
    } catch (error) {
      message.error("Network error. Please check your connection and try again.");
      setLoading(false);
      dispatch(SettingActions.updateSettings({ translationLoading: false }));
    }
  },
    // eslint-disable-next-line
    [location, selectedTranslations, selectedReciterId]);

  const findAllTranslationsWithPaginationList = async () => {
    if (nextPageToken) {
      try {
        let result = await findAllTranslationsWithPagination(nextPageToken);
        if (result && result.status) {
          setAllVerses(prev => {
            const seen = new Set(prev.map(v => `${v.chapterNo}-${v.verseNo}`));
            const newVerses = (result.data.verse || []).filter(v => !seen.has(`${v.chapterNo}-${v.verseNo}`));
            return [...prev, ...newVerses];
          });
          setNextPageToken(result.data.nextPageToken || "");
          setLoading(false);
          dispatch(SettingActions.updateSettings({ translationLoading: false }));
        } else {
          message.error("Failed to load more data. Please try again later.");
          setLoading(false);
          dispatch(SettingActions.updateSettings({ translationLoading: false }));
        }
      } catch (error) {
        message.error("Network error. Please check your connection and try again.");
        setLoading(false);
        dispatch(SettingActions.updateSettings({ translationLoading: false }));
      }
    } else {
      setLoading(false);
      dispatch(SettingActions.updateSettings({ translationLoading: false }));
    }
  };

  const fetchPreviousVerses = useCallback(async () => {
    if (isFetchingPrevRef.current || !prevPageToken) return;
    isFetchingPrevRef.current = true;

    const chapterContent = document.getElementById('chapterContent');
    const oldScrollHeight = chapterContent ? chapterContent.scrollHeight : 0;

    try {
      const result = await findAllTranslationsWithPrevPage(prevPageToken);
      if (result && result.status && result.data?.verse) {
        const newPrevVerses = result.data.verse;
        setPrevPageToken(result.data.prevPageToken || "");
        setAllVerses(prev => {
          const seen = new Set(prev.map(v => `${v.chapterNo}-${v.verseNo}`));
          const unique = newPrevVerses.filter(v => !seen.has(`${v.chapterNo}-${v.verseNo}`));
          return [...unique, ...prev];
        });
        // Restore scroll position after prepending so page does not jump
        requestAnimationFrame(() => {
          if (chapterContent) {
            const newScrollHeight = chapterContent.scrollHeight;
            chapterContent.scrollTop += newScrollHeight - oldScrollHeight;
          }
        });
      }
    } catch (err) {
      console.error("Error fetching previous verses:", err);
    } finally {
      isFetchingPrevRef.current = false;
    }
  // eslint-disable-next-line
  }, [prevPageToken]);

  useEffect(() => {
    // Send request to get verses and its translations
    getAllTranslations()
  },
    [getAllTranslations])

  const scrollToVerse = useCallback((verseNo) => {
    const chapterContent = document.getElementById('chapterContent');
    const currentKey = `${props.selectedSurah}-${verseNo}`;

    const doScroll = () => {
      if (!chapterContent) return false;
      if (parseInt(verseNo, 10) === 1) {
        chapterContent.scrollTop = 0;
        lastScrolledSurahVerse.current = currentKey;
        return true;
      }
      const verseEl = document.getElementById(verseNo.toString());
      if (verseEl) {
        const containerRect = chapterContent.getBoundingClientRect();
        const verseRect = verseEl.getBoundingClientRect();
        chapterContent.scrollTop = Math.max(0, verseRect.top - containerRect.top + chapterContent.scrollTop);
        lastScrolledSurahVerse.current = currentKey;
        return true;
      }
      return false;
    };

    if (!doScroll()) {
      requestAnimationFrame(() => {
        if (!doScroll()) {
          setTimeout(doScroll, 50);
        }
      });
    }
  }, [props.selectedSurah]);

  useEffect(() => {
    if (
      props.selectedVerse &&
      allVerses.length > 0 &&
      allVerses[0].chapterNo === parseInt(props.selectedSurah)  // ensure verses belong to the currently selected surah
    ) {
      const currentKey = `${props.selectedSurah}-${props.selectedVerse}`;
      if (lastScrolledSurahVerse.current !== currentKey) {
        scrollToVerse(props.selectedVerse);
      }
    }
  // eslint-disable-next-line
  }, [props.selectedSurah, props.selectedVerse, allVerses]);

  useEffect(() => {
    setVerseInView(props.selectedVerse);
  }, [props.selectedSurah, props.selectedVerse]);

  const isScrollingRef = useRef(false);

  const handleScroll = (event) => {
    // Dismiss tooltip on any scroll
    if (showTooltip && activeImageIndex !== null) {
      setShowTooltip(false);
      setActiveImageIndex(null);
    }

    const target = event.target;
    const threshold = 1;

    // Scroll DOWN — append next page
    if (target.scrollHeight - target.scrollTop <= target.clientHeight + threshold) {
      if (nextPageToken) {
        setLoading(true);
        dispatch(SettingActions.updateSettings({ translationLoading: true }));
        findAllTranslationsWithPaginationList();
      }
    }

    // Scroll UP — prepend previous page
    if (target.scrollTop <= 50 && prevPageToken) {
      fetchPreviousVerses();
    }

    // Throttle the expensive verse-in-view DOM scan to one per animation frame
    if (isScrollingRef.current) return;
    isScrollingRef.current = true;

    requestAnimationFrame(() => {
      isScrollingRef.current = false;
      const container = target;
      const verseEls = container.querySelectorAll('[data-verse-no]');
      if (verseEls.length === 0) return;
      const containerRect = container.getBoundingClientRect();
      const visibleTop = containerRect.top + 80;
      let bestVerse = null;
      let bestDiff = Infinity;
      verseEls.forEach((el) => {
        const verseNo = parseInt(el.getAttribute('data-verse-no'), 10);
        const rect = el.getBoundingClientRect();
        const diff = rect.top - visibleTop;
        if (diff <= 0) {
          if (-diff < bestDiff) {
            bestDiff = -diff;
            bestVerse = verseNo;
          }
        } else if (diff < bestDiff) {
          bestDiff = diff;
          bestVerse = verseNo;
        }
      });
      if (bestVerse != null) {
        setVerseInView(bestVerse);
      }
    });
  };


  useEffect(() => {
    // console.log('playingVerseRef = ', playingVerseRef.current);
    // console.log('jumpToVerse = ', jumpToVerse);
    if (playingVerseRef.current && jumpToVerse) {
      playingVerseRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
    /*else if(!playingVerseRef.current && jumpToVerse) {
      // scroll to top of the page
      scrollToTopOfPage()
    }*/
  }, [playingVerse, jumpToVerse]);

  useEffect(() => {  
    if(allVerses.length  > 0)
    {
      //   console.log('allverses:',allVerses[allVerses.length - 1]) 
      // console.log('playingVerse:',playingVerse)
      // console.log('playingSurah:',playingSurah)

      if(playingVerse > allVerses[allVerses.length - 1].verseNo && playingSurah === allVerses[allVerses.length - 1].chapterNo)
      {
        findAllTranslationsWithPaginationList();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allVerses]);

  //Calling child function in Parent component
  const callPlayFunction = (newPlayingSurah,newPlayingVerse) => {
    if (props.audioBarRef?.current) {
      // console.log('playingVerse:',playingVerse)
      // console.log('newPlayingVerse:',newPlayingVerse)
      // console.log('newPlayingSurah:',newPlayingSurah)
      // console.log('playingSurah:',playingSurah)
      // console.log('playstate:', playState)
      const isSameSurah = newPlayingSurah === playingSurah;
      const isSameVerse = newPlayingVerse === playingVerse;
      if (isSameSurah && isSameVerse && playState) {
        // Pause the audio
        dispatch(SettingActions.updateSettings({ playState: !playState }));
      } else {
        // Play the audio
        props.audioBarRef.current.playVerse(newPlayingSurah,newPlayingVerse, true,true);
       // dispatch(SettingActions.updateSettings({ playState: !playState }));
        dispatch(SettingActions.updateSettings({ playingSurah: newPlayingSurah }));

      }
    

    }
  };

  const copyVerse = async (verse) => {
    try {
      // Only include translations when "Show translations" is enabled
      const translationsToCopy = showTranslation ? (verse.translations || []) : [];

      const htmlContent = `
        <div dir="rtl">${verse.text}</div>
        ${translationsToCopy
          .map(t => {
            const dir = getTranslationDirection(t.translationText);
            return `
              <div dir="${dir}">
                ${t.translationText}
                <div style="font-size: 0.8em; color: gray;">— ${t.translator?.translatorName || ''}</div>
              </div>
            `;
          })
          .join("")}
      `;

      const plainText = [
        verse.text,
        ...(translationsToCopy.map(
          t => `${t.translationText} — ${t.translator?.translatorName || ''}`
        ))
      ].join("\n");

      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([htmlContent], { type: "text/html" }),
          "text/plain": new Blob([plainText], { type: "text/plain" }),
        }),
      ]);

      message.success(t('verse-coppied'));
    } catch (error) {
      console.error('Failed to copy verse:', error);
      message.error(t('failed-to-copy-verse'));
    }
  };

  const openGrammerModal = (verseGrammer, verseid) => {
    setIsGrammerModalOpen(true);
    setGrammerModalVerse(verseGrammer);
    setGrammerModalVerseId(verseid);
  };

  const closeGrammerModal = () => {
    setIsGrammerModalOpen(false);
  };

  const updateGrammerVerseId = (newId) => {
    setGrammerModalVerseId(newId);
  };
  const AddToLastRead = (chap_No, verse_No) => {
    dispatch(SettingActions.updateSettings({ lastRead: chap_No + ':' + verse_No }));
    message.success(t('set-last-read'));
    HideAddPlusPopup()
  };

  const AddToBookMark = async (verseId, verseNo, chapterNo, chapterName) => {
    HideAddPlusPopup()
    setLoading(true);
    let result = await addToBookmark(verseId, verseNo, chapterNo, chapterName);
    if (result &&  result.status === 201) {
      const verseToUpdate = allVerses.find((verse) => verse.id === verseId);
      if (verseToUpdate) {
        // Push the bookmark data into the 'bookmark' list of that verse        
        verseToUpdate.bookmark.push({ 'chapterName': chapterName, 'verseId': verseId, 'chapterNo': chapterNo, 'verseNo': verseNo });
      }
      message.success(t('bookmark-success'));
    }
    setLoading(false);
  };

  const RemoveBookmark = async (verseId) => {
    HideAddPlusPopup()
    if (isBookmarkConfirmationsModalOpen) {
      setIsBookmarkConfirmationsModalOpen(false)
    }
    setLoading(true);
    let result = await deleteBookmark(verseId);
    if (result && result.status === 200) {
      const verseToUpdate = allVerses.find((verse) => verse.id === verseId);
      if (verseToUpdate) {
        // Clear the 'bookmark' list of that verse
        verseToUpdate.bookmark = [];
      }
      message.success(t('remove-bookmark-success-msg'));
    }
    setLoading(false);
  };
  const bookmarkDeleteConfirmation = (verseId) => {
    setIsBookmarkConfirmationsModalOpen(true)
    setDeleteNotesId(verseId)
  }

  const AddToNotes = (singleVerse) => {
    setNotesData(singleVerse)
    setIsNotesModalOpen(true);
    HideAddPlusPopup()

  };

  const closeNotesModal = () => {
    setIsNotesModalOpen(false);
  };

  const closeDeleteConfirmationModal = () => {
    setIsDeleteConfirmationsModalOpen(false);
  };

  const closeBookmarkDeleteConfirmationModal = () => {
    setIsBookmarkConfirmationsModalOpen(false);
  };

  const HideAddPlusPopup = () => {
    setShowTooltip(false);
    setActiveImageIndex(null);
  };

  const AddToCollections = (verseId) => {
    HideAddPlusPopup()
    setNotesData([verseId])
    setIsCollectionModalOpen(true);
  };

  const closeCollectionModal = () => {
    setIsCollectionModalOpen(false);
  };

  const closeAddNewCollectionModal = () => {
    setIsAddNewCollectionModalOpen(false);
  };
  const onDeleteNotesBadge = (singleVerse) => {
    setNotesData(singleVerse)
    setIsDeleteConfirmationsModalOpen(true);
    setIsNotesModalOpen(false);
  };

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((authUser) => {
      if (authUser) {
        setUser(authUser);
      } else {
        setUser(null);
      }
    });
    return () => {
      unsubscribe();
    };
  }, []); // mount once — re-subscribing on every user change causes a listener loop


  const SearchWord = (word, rootWord) => {
    if (rootWord !== null && rootWord !== undefined && rootWord.length > 0) {
      navigate('/search/rootword:' + rootWord);
    }
    else {
      navigate('/search/' + word);

    }
  }

  const removeQuranicSymbols = (verse) => {
    return verse.replace(ARABIC_CHARS_REGEX, '');
  };  
  
  // Skip hover-search for tokens that are only tajweed/diacritic symbols.
  const isSearchableArabicWord = (word) => {
    if (!word) return false;
    const stripped = removeQuranicSymbols(String(word)).trim();
    return /[\u0621-\u064A]/.test(stripped);
  };

  const getMappedTranslationIndex = (completeVerse, hoveredIndex) => {
    if (hoveredIndex == null || hoveredIndex < 0) return -1;
    const tokens = String(completeVerse || '').replace(/\s+/g, ' ').trim().split(' ');
    if (!tokens[hoveredIndex] || !isSearchableArabicWord(tokens[hoveredIndex])) return -1;
    let mapped = -1;
    for (let i = 0; i <= hoveredIndex && i < tokens.length; i += 1) {
      if (isSearchableArabicWord(tokens[i])) mapped += 1;
    }
    return mapped;
  };
  

  const togglePopupOverVerse = (index1, index, word) => {
    if (!isSearchableArabicWord(word)) {
      setShowVerseHoverPopup(false);
      setActiveVerseWordIndex(null);
      setActiveVerseIndex(null);
      return;
    }
    setCursorInsidePopupDiv(true)
    setActiveVerseWordIndex(activeVerseWordIndex === index1 ? null : index1);
    setActiveVerseIndex(index)
    setShowVerseHoverPopup(!showVerseHoverPopup);
  };
  const handleMouseLeave = () => {
      setActiveVerseWordIndex(null);
      setActiveVerseIndex(null);
  };

  const handleMouseEnterPopup = () => {
    setCursorInsidePopupDiv(true)

  };
  
  const handleMouseLeavePopup = () => {
    setCursorInsidePopupDiv(false)
  };
 
  const WordPoup = (word, versewordbywordTranslation, index,complete_verse) => {
    try
    {

    const selectedWord = getMappedTranslationIndex(complete_verse, index);
    if (selectedWord < 0 || !versewordbywordTranslation || !versewordbywordTranslation[selectedWord]) {
      return null;
    }
    let filterString = versewordbywordTranslation[selectedWord].translation

    if (/-/.test(filterString)) {
      filterString = filterString.replace(/-/g, ' ');
    }
    if (/,/.test(filterString)) {
      filterString = filterString.replace(/,/g, ' ');
    }
    if (/\./.test(filterString)) {
      filterString = filterString.replace(/\./g, ' ');
    }
    filterString = filterString.replace(/\s+/g, ' ').trim();

    if (versewordbywordTranslation[selectedWord] === null || versewordbywordTranslation[selectedWord] === undefined)
      return null;
    else
      return (
        <div className="word_popup_outside_div popuppp ">
        {cursorInsidePopupDiv && (
        <div className={`darkBackground word_popup `}
        onClick={(e) => {
          e.stopPropagation();
          // console.log("Popup clicked");
        }}
        onMouseEnter={() => handleMouseEnterPopup()} onMouseLeave={() => handleMouseLeavePopup()} >
          {/* {versewordbywordTranslation[selectedWord].root && versewordbywordTranslation[selectedWord].root.length>0 && */}
          <div className={` w-auto align-self-center pl-2 mr-4 verse-popup-text themePopup `} nowrap="true">
            {/* {versewordbywordTranslation[selectedWord].root} */}
            {word}
          </div>
          {/* } */}
          <div
            className={`w-auto align-self-center pl-wordpopup-4 verse-popup-text themePopup nowrapword`}
            nowrap="true">
            {filterString}
          </div>
          <div
            className='  w-auto verse_button text-white align-self-center ml-buuton-4 cursor_pointer search-button-verse-popup'
            onClick={() => SearchWord(word, versewordbywordTranslation[selectedWord].root)}
            nowrap="true">
           {(t('search'))}
          </div>
        </div>
          )}
          </div>
      );
    }
    catch(e){
      console.log("erros is e:",e)
    }
  };


  const handlePlusClick = (index) => {
    setShowTooltip(!showTooltip);
    setActiveImageIndex(activeImageIndex === index ? null : index);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (showTooltip && activeImageIndex !== null && !e.target.closest('.tooltip-container')) {
        // Clicked outside the tooltip container, hide the tooltip
        setShowTooltip(false);
        setActiveImageIndex(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleClickOutside);

    };
  }, [showTooltip, activeImageIndex]);

 
  const wordRefs = useRef([]);
  return (
    <Home
      loading={loading}
      setLoading={setLoading}
      selectedSurah={props.selectedSurah}
      selectedVerse={props.selectedVerse}
      verseInView={verseInView}
      t={t}
      allVerses={allVerses}
      playingVerse={playingVerse}
      playingSurah={playingSurah}
      copyVerse={copyVerse}
      openGrammerModal={openGrammerModal}
      user={user}
      setUser={setUser}
      AddToCollections={AddToCollections}
      AddToNotes={AddToNotes}
      RemoveBookmark={RemoveBookmark}
      AddToBookMark={AddToBookMark}
      AddToLastRead={AddToLastRead}
      onDeleteNotesBadge={onDeleteNotesBadge}
      bookmarkDeleteConfirmation={bookmarkDeleteConfirmation}
      showTranslation={showTranslation}
      handleScroll={handleScroll}
      location={location}
      chapters={chapters}
      reciterNames={reciterNames}
      playingVerseRef={playingVerseRef}
      callPlayFunction={callPlayFunction}
      playState={playState}
      isVariablePresent={isVariablePresent}
      selectedReciterId={selectedReciterId}
      selectedReciterName={selectedReciterName}
      isGrammerModalOpen={isGrammerModalOpen}
      setIsGrammerModalOpen={setIsGrammerModalOpen}
      grammerModalVerse={grammerModalVerse}
      setGrammerModalVerseId={setGrammerModalVerseId}
      grammerModalVerseId={grammerModalVerseId}
      isNotesModalOpen={isNotesModalOpen}
      setIsNotesModalOpen={setIsNotesModalOpen}
      notesData={notesData}
      setNotesData={setNotesData}
      deleteNotesId={deleteNotesId}
      setDeleteNotesId={setDeleteNotesId}
      isDeleteConfirmationsModalOpen={isDeleteConfirmationsModalOpen}
      setIsDeleteConfirmationsModalOpen={setIsDeleteConfirmationsModalOpen}
      isCollectionModalOpen={isCollectionModalOpen}
      setIsAddNewCollectionModalOpen={setIsAddNewCollectionModalOpen}
      isAddNewCollectionModalOpen={isAddNewCollectionModalOpen}
      isBookmarkConfirmationsModalOpen={isBookmarkConfirmationsModalOpen}
      setIsBookmarkConfirmationsModalOpen={setIsBookmarkConfirmationsModalOpen}
      closeNotesModal={closeNotesModal}
      closeDeleteConfirmationModal={closeDeleteConfirmationModal}
      closeBookmarkDeleteConfirmationModal={closeBookmarkDeleteConfirmationModal}
      closeGrammerModal={closeGrammerModal}
      updateGrammerVerseId={updateGrammerVerseId}
      closeCollectionModal={closeCollectionModal}
      closeAddNewCollectionModal={closeAddNewCollectionModal}
      setIsCollectionModalOpen={setIsCollectionModalOpen}
      HideAddPlusPopup={HideAddPlusPopup}
      WordPoup={WordPoup}
      handlePlusClick={handlePlusClick}
      showTooltip={showTooltip}
      activeImageIndex={activeImageIndex}
      setActiveImageIndex={setActiveImageIndex}
      togglePopupOverVerse={togglePopupOverVerse}
      showVerseHoverPopup={showVerseHoverPopup}
      activeVerseWordIndex={activeVerseWordIndex}
      activeVerseIndex={activeVerseIndex}
      handleMouseLeave={handleMouseLeave}
      wordRefs={wordRefs}
      translationFontSize={translationFontSize}
      arabicFontSize={arabicFontSize}
      scriptStyle={scriptStyle}
      setShowTooltip={setShowTooltip}
      topOfPageRef={topOfPageRef}
      FirstVerse={FirstVerse}
      CopyVerse={CopyVerse}
      userTheme={userTheme}
      // indoPakVerses={indoPakVerses}
    />
  );
};

export default HomeContainer;
